import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SkeletonLoaderLegacyComponent } from '@mkp/shared/ui-library';

@Component({
  selector: 'mkp-product-table-skeleton',
  imports: [SkeletonLoaderLegacyComponent],
  templateUrl: './product-table-skeleton.component.html',
  styleUrl: './product-table-skeleton.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductTableSkeletonComponent {}
